<mat-form-field class="item-selector" floatLabel="always">
  <mat-label>
    {{ config.filters?.itemType | displayLabelPipe }}
  </mat-label>
  <ng-container *ngIf="templateState$ | async as state; else loadingState">
    <ng-container *ngIf="state.initialized; else loadingState">
      <div class="dropdown-container">
        <input
          type="text"
          data-cy="item-search-select-input"
          [formControl]="searchCtrl"
          [matAutocomplete]="autocomplete"
          matInput
          onfocus="this.select()"
        />
        <mat-icon class="selector-arrow cursor-pointer" matSuffix>arrow_drop_down</mat-icon>
        <mat-autocomplete
          #autocomplete="matAutocomplete"
          (optionSelected)="addItem($event, state.selectedItem)"
          [displayWith]="displayFn(state.selectedItem)"
        >
          <mat-option *ngFor="let appSummary of state.availableItems" [value]="appSummary">
            <div class="item-option">
              {{ appSummary.name }}
            </div>
          </mat-option>
          <glxy-infinite-scroll-trigger
            [visiblilityMargin]="60"
            (isVisible)="loadMore()"
          ></glxy-infinite-scroll-trigger>
        </mat-autocomplete>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #loadingState>
    <div class="stencil-shimmer loading-state">
      <input matInput disabled />
    </div>
  </ng-template>
</mat-form-field>
